export enum Colors {
    navy = '#28516b',
    cloud = '#e9f1fa',
    earth = '#968886',
    coral = '#ff7b67',
    tangerine = '#ffbf78',
    dullTangerine = '#FCBE7889',
    blush = '#f9b7bb',
    aqua = '#b4e1e3',
    olive = '#809b7d',
    disabledGrey = '#D6D2D0',
    dullCoral = '#F37A6A',
    lightblue = '#E6F5FF',
    tan = '#F5F0ED',
    grey = '#807E7D',
    mediumGrey = '#807E7D', // start of new color palette
    lightGrey = '#F7F6F6',
    green = '#C4FF12',
    mediumGreen = '#E7FFA0',
    lightGreen = '#F3FFD0',
    turquoise = '#00A68D',
    mediumTurq = '#A1DBD3',
    lightTurq = '#E8F6F4',
    red = '#880D30',
    mediumRed = '#E31650',
    lightRed = '#F9D9DC',
    darkNavy = '#002F4D',
    mediumNavy = '#335971',
    white = '#FDFDFD',
    terraCotta = '#ED6A5A',
    error = '#FF0000',
}

export enum Links {
    payquicker = 'https://tandem.mypayquicker.com',
    joinTandem = 'https://www.join-tandem.com/',
}
